<!-- External link -->
@if (link.external) {
  <a
    [class]="cssPrefix + '__nav-item-content'"
    href="javascript:void(0)"
    (click)="onLinkClick()"
    [matTooltip]="showTooltip ? tooltipText : ''"
    [matTooltipPosition]="tooltipPosition">
    <ng-container *ngTemplateOutlet="navContent"></ng-container>
  </a>
}

<!-- Internal link -->
@if (!link.external) {
  <a
    [class]="cssPrefix + '__nav-item-content'"
    [routerLink]="resolvedUrl"
    [queryParams]="link.queryParams"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
    (click)="onLinkClick()"
    [matTooltip]="showTooltip ? tooltipText : ''"
    [matTooltipPosition]="tooltipPosition">
    <ng-container *ngTemplateOutlet="navContent"></ng-container>
  </a>
}

<ng-template #navContent>
  <div [class]="cssPrefix + '__nav-item-left'">
    <mat-icon [class]="cssPrefix + '__nav-icon'" [svgIcon]="'cfa-' + link.icon"></mat-icon>
    @if (showLabel) {
      <span [class]="cssPrefix + '__nav-label'">{{ link.label }}</span>
    }
  </div>
</ng-template>
